var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarkdownIcon = function SvgMarkdownIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#697477",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M17.708 5.625c0-.92-.746-1.667-1.666-1.667H3.958c-.92 0-1.666.747-1.666 1.667v8.75c0 .92.746 1.667 1.666 1.667h12.084c.92 0 1.666-.747 1.666-1.667z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#697477",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M5.625 11.875v-3.75L7.5 10l1.875-1.875v3.75M13.125 8.125v3.75l-1.458-1.458M13.125 11.875l1.458-1.458"
  })));
};
export { SvgMarkdownIcon as ReactComponent };
export default __webpack_public_path__ + "65b1efc8291a8a2ee4783dc648799e84.svg";